import { useSceneHandlers } from '../hooks/SceneHandlersContext';

/**
 * 一時素材 (tempMaterials) / クラウド素材 (cloudMaterials) の無限クエリから
 * 素材を 1 件引くヘルパー。SceneItem 配下の各所で
 * `tempMaterials.data?.pages.flatMap(...)` を書き下していたのを 1 箇所に集約する。
 *
 * - `findLoadedMaterial`: 読み込み済みページ内だけを同期で探す (見つからなければ undefined)
 * - `resolveMaterial`: 同期で見つからなければ API から 1 件取得して返す
 */
export function useMaterialLookup() {
  const { tempMaterials, cloudMaterials, fetchMaterialById } = useSceneHandlers();

  const findLoadedMaterial = (materialId: string | null | undefined): any | undefined => {
    if (!materialId) return undefined;
    const tempItems = tempMaterials.data?.pages.flatMap((page: any) => page.items) || [];
    const cloudItems = cloudMaterials.data?.pages.flatMap((page: any) => page.items) || [];
    return [...tempItems, ...cloudItems].find((m: any) => m.id === materialId);
  };

  const resolveMaterial = async (materialId: string | null | undefined): Promise<any | undefined> => {
    if (!materialId) return undefined;
    const loaded = findLoadedMaterial(materialId);
    if (loaded) return loaded;
    return (await fetchMaterialById(materialId)) ?? undefined;
  };

  return { findLoadedMaterial, resolveMaterial };
}
